import axios from './axiosInstance';
import { setUploadedHeroes } from '../pages/sena/senaAssets';

// 관리자 화면에서 등록된 영웅은 이미지가 번들이 아니라 서버에 있다.
// 이름 목록을 1회만 받아 senaAssets 에 주입하고, 영웅 이미지를 그리는 조회 API 앞에 붙여
// 첫 렌더부터 URL 폴백이 적용되게 한다.
let uploadedHeroesPromise = null;
const withUploadedHeroes = (call) => {
  if (!uploadedHeroesPromise) {
    uploadedHeroesPromise = axios.get('/sena/hero/img-list')
      .then((res) => setUploadedHeroes(res.data))
      .catch(() => setUploadedHeroes([]));
  }
  return uploadedHeroesPromise.then(call);
};

// 영웅
export const getHeroList = (heroType) =>
  withUploadedHeroes(() => axios.get('/sena/hero/list', { params: { heroType } }));

export const getHeroSkills = (heroId) =>
  axios.get(`/sena/hero/${heroId}/skills`);

export const addHero = (data) =>
  axios.post('/sena/hero', data);

// 영웅 도감 캡쳐 1장으로 등록 (ADMIN) — 스킬 개수는 서버가 아이콘 개수로 판정
export const registerHero = (heroNm, captureFile) => {
  const form = new FormData();
  form.append('heroNm', heroNm);
  form.append('capture', captureFile);
  return axios.post('/sena/hero/register', form);
};

// 컨텐츠 적군
export const getContentEnemies = (contentType, subType) =>
  axios.get('/sena/content/enemy', { params: { contentType, subType } });

// 공략
export const getGuideList = (contentType, subType) =>
  axios.get('/sena/guide/list', { params: { contentType, subType } });

export const getGuideDetail = (guideId) =>
  withUploadedHeroes(() => axios.get(`/sena/guide/${guideId}`));

export const saveGuide = (data) =>
  axios.post('/sena/guide', data);

export const deleteGuide = (guideId) =>
  axios.delete(`/sena/guide/${guideId}`);

// 길드전
export const getGwDeckList = (keyword) =>
  axios.get('/sena/gw/deck/list', { params: { keyword } });

export const saveGwDeck = (data) =>
  axios.post('/sena/gw/deck', data);

export const deleteGwDeck = (deckId) =>
  axios.delete(`/sena/gw/deck/${deckId}`);

export const getGwCounterList = (deckId) =>
  axios.get('/sena/gw/counter/list', { params: { deckId } });

export const getGwCounterDetail = (counterId) =>
  withUploadedHeroes(() => axios.get(`/sena/gw/counter/${counterId}`));

export const saveGwCounter = (data) =>
  axios.post('/sena/gw/counter', data);

export const deleteGwCounter = (counterId) =>
  axios.delete(`/sena/gw/counter/${counterId}`);

// 총력전
export const getTwGuideList = () =>
  axios.get('/sena/tw/list');

export const getTwGuideDetail = (twGuideId) =>
  withUploadedHeroes(() => axios.get(`/sena/tw/${twGuideId}`));

export const saveTwGuide = (data) =>
  axios.post('/sena/tw', data);

export const deleteTwGuide = (twGuideId) =>
  axios.delete(`/sena/tw/${twGuideId}`);

// 인증
export const senaRefreshToken = () =>
  axios.post('/sena/auth/refresh');

export const senaSignup = (loginId, passWd, userName) =>
  axios.post('/sena/auth/signup', { loginId, passWd, userName });

export const senaLogin = (loginId, passWd) =>
  axios.post('/sena/auth/login', { loginId, passWd });

// 내 정보
export const senaGetMyInfo = () =>
  axios.get('/sena/auth/me');

export const senaUpdateMyInfo = (data) =>
  axios.put('/sena/auth/me', data);

// 회원관리
export const getAdminUsers = (userRole) =>
  axios.get('/sena/admin/users', { params: { userRole } });

export const updateAdminUserRole = (loginId, userRole) =>
  axios.put('/sena/admin/users/role', { loginId, userRole });

export const updateAdminUserPuuid = (loginId, puuid) =>
  axios.put('/sena/admin/users/puuid', { loginId, puuid });

export const getAdminAllPuuids = () =>
  axios.get('/sena/admin/users/puuids');

// 길드전 방어 덱
export const getGwDefenseList = () =>
  withUploadedHeroes(() => axios.get('/sena/gw/defense/list'));

export const getGwDefense = (defenseId) =>
  axios.get(`/sena/gw/defense/${defenseId}`);

export const saveGwDefense = (data) =>
  axios.post('/sena/gw/defense', data);

export const deleteGwDefense = (defenseId) =>
  axios.delete(`/sena/gw/defense/${defenseId}`);

export const deleteAdminUser = (loginId) =>
  axios.delete(`/sena/admin/users/${encodeURIComponent(loginId)}`);

// 쿠폰 일괄등록 배치 (비동기)
export const startSenaCouponBatch = (couponCodes) =>
  axios.post('/sena/coupon/batch-async', { couponCodes });

export const getSenaCouponBatchStatus = (execId) =>
  axios.get(`/sena/coupon/batch/${execId}/status`);

export const getSenaCouponBatchHistory = () =>
  axios.get('/sena/coupon/batch/history');

export const checkSenaCouponDuplicates = (codes) =>
  axios.get('/sena/coupon/batch/check', { params: { codes: codes.join(',') } });
